import { MyMonitoringLogoOnly } from '@apps-common/components/common/logos'

interface IProps {
  loading?: boolean
  companyId?: string
  companyName?: string
  companyLogoUrl?: string
}

export const NavbarCompany: React.FC<IProps> = ({ loading, companyId, companyLogoUrl }) => (
  <div className='flex items-center justify-between gap-[20px] bg-logo-background rounded-xl px-[10px] py-[5px]'>
    <MyMonitoringLogoOnly color='fill-primary-content' classes='h-[40px]' />
    {/* <MyMonitoringSiteCompanyLogo loading={loading} companyId={companyId} companyLogoUrl={companyLogoUrl} /> */}
  </div>
)
